<template>
  <!-- Header -->
  <header id="header" class="ex-header">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h1>{{ title }}</h1>
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->
    </div>
    <!-- end of container -->
  </header>
  <!-- end of ex-header -->
  <!-- end of header -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      require: true,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
#header {
  h1 {
    text-align: center;
    padding: 100px 0 40px;
  }
}
</style>
